(function () {
  'use strict';

  if (window.ShrineCartPageRepairV3) return;
  window.ShrineCartPageRepairV3 = true;

  var pendingLines = new Set();
  var productRequests = new Map();

  function jsonRoute(route, fallback) {
    var value = String(route || fallback || '');
    return /\.js(?:\?|$)/.test(value) ? value : value.replace(/\/$/, '') + '.js';
  }

  var changeUrl = jsonRoute(window.routes && window.routes.cart_change_url, '/cart/change');
  var updateUrl = jsonRoute(window.routes && window.routes.cart_update_url, '/cart/update');
  var cartJsonUrl = jsonRoute(window.routes && window.routes.cart_url, '/cart');

  function numberValue(value, fallback) {
    var parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function eventElement(target) {
    if (!target) return null;
    return target.nodeType === 1 ? target : target.parentElement;
  }

  function formatMoney(cents, currency) {
    var code = currency || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100) + ' ' + code;
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2) + ' ' + code;
    }
  }

  function lineContext(control) {
    var row = control && control.closest ? control.closest('.cart-item') : null;
    var quantityBox = control && control.closest ? control.closest('quantity-input') : null;
    var input = (quantityBox && quantityBox.querySelector('input.quantity__input, input[name="updates[]"]')) ||
      (row && row.querySelector('input.quantity__input, input[name="updates[]"]'));
    var remove = control && control.closest ? control.closest('cart-remove-button') : null;
    var line = Number.parseInt(
      (input && input.dataset.index) ||
      (remove && remove.dataset.index) ||
      '',
      10
    );

    if ((!Number.isInteger(line) || line < 1) && row && row.id) {
      var match = row.id.match(/CartItem-(\d+)/i);
      if (match) line = Number.parseInt(match[1], 10);
    }

    if ((!Number.isInteger(line) || line < 1) && row) {
      var rows = Array.prototype.slice.call(document.querySelectorAll('cart-items .cart-item'));
      var position = rows.indexOf(row);
      if (position >= 0) line = position + 1;
    }

    return { row: row, input: input, line: line };
  }

  function buttonAction(button) {
    var name = String(button.getAttribute('name') || button.dataset.action || '').toLowerCase();
    if (name === 'plus' || name === 'increase' || name === 'increment') return 'plus';
    if (name === 'minus' || name === 'decrease' || name === 'decrement') return 'minus';

    var label = String(button.getAttribute('aria-label') || button.textContent || '').toLowerCase();
    if (/increase|add|plus/.test(label)) return 'plus';
    if (/decrease|remove|minus/.test(label)) return 'minus';

    var box = button.closest('quantity-input');
    if (box) {
      var buttons = Array.prototype.slice.call(box.querySelectorAll('button'));
      if (buttons.length > 1) return buttons.indexOf(button) === buttons.length - 1 ? 'plus' : 'minus';
    }
    return '';
  }

  function setBusy(row, busy) {
    if (!row) return;
    row.setAttribute('aria-busy', busy ? 'true' : 'false');
    row.classList.toggle('is-updating', busy);
    row.querySelectorAll('quantity-input button, cart-remove-button a, cart-remove-button button').forEach(function (control) {
      if ('disabled' in control) control.disabled = busy;
      control.style.pointerEvents = busy ? 'none' : '';
      control.setAttribute('aria-disabled', busy ? 'true' : 'false');
    });
  }

  function clearError(row) {
    var local = row && row.querySelector('.cart-item__error-text');
    var global = document.getElementById('cart-errors');
    if (local) local.textContent = '';
    if (global) global.textContent = '';
  }

  function showError(row, message) {
    var local = row && row.querySelector('.cart-item__error-text');
    var global = document.getElementById('cart-errors');
    var target = local || global;
    if (target) target.textContent = message || 'There was an error while updating your cart. Please try again.';
  }

  function sectionDetails() {
    var itemsHost = document.getElementById('main-cart-items');
    var footerHost = document.getElementById('main-cart-footer');
    var itemsId = itemsHost && itemsHost.dataset.id;
    var footerId = footerHost && footerHost.dataset.id;
    return {
      itemsId: itemsId,
      footerId: footerId,
      ids: [itemsId, footerId].filter(Boolean)
    };
  }

  function parseHtml(html) {
    return new DOMParser().parseFromString(String(html || ''), 'text/html');
  }

  function renderCartSections(sections, cart, details) {
    if (!sections || !details) return false;
    var rendered = false;

    if (details.itemsId && sections[details.itemsId]) {
      var itemsDocument = parseHtml(sections[details.itemsId]);
      var freshCartItems = itemsDocument.querySelector('cart-items');
      var currentCartItems = document.querySelector('cart-items');
      if (freshCartItems && currentCartItems) {
        currentCartItems.replaceWith(freshCartItems);
        rendered = true;
      }
    }

    if (details.footerId && sections[details.footerId]) {
      var footerDocument = parseHtml(sections[details.footerId]);
      var freshSubtotal = footerDocument.querySelector('#main-cart-footer .js-contents');
      var currentSubtotal = document.querySelector('#main-cart-footer .js-contents');
      if (freshSubtotal && currentSubtotal) {
        currentSubtotal.replaceWith(freshSubtotal);
        rendered = true;
      }

      var footer = document.getElementById('main-cart-footer');
      if (footer) footer.classList.toggle('is-empty', Number(cart && cart.item_count || 0) === 0);
    }

    var checkout = document.getElementById('checkout');
    if (checkout) checkout.disabled = Number(cart && cart.item_count || 0) === 0;
    return rendered;
  }

  async function fetchRenderedSections(details) {
    if (!details.ids.length) return null;
    var url = new URL(window.location.href);
    url.searchParams.set('sections', details.ids.join(','));
    url.searchParams.set('_cart_ajax', String(Date.now()));

    var response = await fetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Cart sections could not be refreshed.');
    return response.json();
  }

  function updateCartCount(cart) {
    var count = Number(cart && cart.item_count || 0);
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = String(count);
      node.setAttribute('data-cart-count', String(count));
    });
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      bubble.classList.toggle('hidden', count === 0);
      var numberNode = bubble.querySelector('span[aria-hidden="true"], span:first-child');
      if (numberNode) numberNode.textContent = String(count);
      var labelNode = bubble.querySelector('.visually-hidden');
      if (labelNode) labelNode.textContent = count + (count === 1 ? ' item' : ' items');
    });
  }

  function productJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (productRequests.has(handle)) return productRequests.get(handle);

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var request = fetch(root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });

    productRequests.set(handle, request);
    return request;
  }

  function createPriceNode(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    node.textContent = text;
    return node;
  }

  async function hydrateComparePrices(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var currency = cart.currency || 'GBP';

    await Promise.all(cart.items.map(async function (item, index) {
      var row = document.getElementById('CartItem-' + (index + 1));
      if (!row) return;

      var details = row.querySelector('.cart-item__details');
      var name = details && details.querySelector('.cart-item__name');
      if (!details || !name) return;

      var oldSummary = details.querySelector('.em-cart-price-summary');
      if (oldSummary) oldSummary.remove();

      var nativePrice = name.nextElementSibling;
      if (nativePrice && nativePrice.classList.contains('em-cart-price-summary')) nativePrice = nativePrice.nextElementSibling;
      if (nativePrice) nativePrice.hidden = false;

      var product = await productJson(item.handle);
      if (!product || !Array.isArray(product.variants)) return;
      var variant = product.variants.find(function (entry) {
        return Number(entry.id) === Number(item.variant_id);
      });
      var compareAt = Number(variant && variant.compare_at_price || 0);
      var salePrice = Number(item.final_price || item.price || 0);
      if (!(compareAt > salePrice)) return;

      if (nativePrice) nativePrice.hidden = true;
      var summary = document.createElement('div');
      summary.className = 'em-cart-price-summary';
      summary.appendChild(createPriceNode('s', 'em-cart-price-summary__compare', formatMoney(compareAt, currency)));
      summary.appendChild(createPriceNode('strong', 'em-cart-price-summary__sale', formatMoney(salePrice, currency)));
      summary.appendChild(createPriceNode(
        'span',
        'em-cart-price-summary__saving',
        'You save ' + formatMoney(compareAt - salePrice, currency) + ' each'
      ));
      name.insertAdjacentElement('afterend', summary);
    }));
  }

  function addStyles() {
    var oldStyle = document.getElementById('ShrineCartPageRepairStyles');
    if (oldStyle) oldStyle.remove();

    var style = document.createElement('style');
    style.id = 'ShrineCartPageRepairStyles';
    style.textContent =
      '.em-cart-special-instructions{width:100%;max-width:52rem;margin:0 0 2rem}' +
      '.em-cart-special-instructions__label{display:block;margin:0 0 .8rem;font-weight:600}' +
      '.em-cart-special-instructions__textarea{display:block;width:100%;min-height:11rem;padding:1.2rem 1.4rem;border:1px solid rgba(var(--color-foreground),.25);border-radius:8px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));font:inherit;resize:vertical}' +
      '.em-cart-special-instructions__status{min-height:1.8rem;margin-top:.5rem;font-size:1.2rem;opacity:.7}' +
      '.cart-item.is-updating{opacity:.62;transition:opacity .18s ease}' +
      '.em-cart-price-summary{display:flex;align-items:center;flex-wrap:wrap;gap:.55rem .9rem;margin:.65rem 0 .25rem}' +
      '.em-cart-price-summary__compare{opacity:.58;text-decoration-thickness:1px}' +
      '.em-cart-price-summary__sale{font-weight:700}' +
      '.em-cart-price-summary__saving{display:block;flex-basis:100%;font-size:1.2rem;font-weight:700;color:#ff0000!important}' +
      '@media screen and (max-width:749px){.em-cart-special-instructions{max-width:none}}';
    document.head.appendChild(style);
  }

  function installCartNote(cart) {
    var footer = document.querySelector('.cart__footer');
    var blocks = footer && footer.querySelector('.cart__blocks');
    if (!footer || !blocks) return;

    var note = document.getElementById('Cart-note');
    var status;
    if (!note) {
      var wrap = document.createElement('div');
      wrap.className = 'em-cart-special-instructions';
      wrap.innerHTML = '<label class="em-cart-special-instructions__label" for="Cart-note">Order special instructions</label><textarea class="em-cart-special-instructions__textarea" id="Cart-note" name="note" form="cart" placeholder="Add delivery notes, gift details, or other requests"></textarea><div class="em-cart-special-instructions__status" role="status" aria-live="polite"></div>';
      footer.insertBefore(wrap, blocks);
      note = wrap.querySelector('#Cart-note');
      status = wrap.querySelector('.em-cart-special-instructions__status');
    } else {
      var label = document.querySelector('label[for="Cart-note"]');
      if (label) label.textContent = 'Order special instructions';
      status = note.parentNode.querySelector('.em-cart-special-instructions__status');
      if (!status) {
        status = document.createElement('div');
        status.className = 'em-cart-special-instructions__status';
        note.parentNode.appendChild(status);
      }
    }

    if (cart && typeof cart.note === 'string' && document.activeElement !== note) note.value = cart.note;
    if (note.dataset.emCartNoteBound === 'true') return;
    note.dataset.emCartNoteBound = 'true';

    var timer;
    function saveNote() {
      window.clearTimeout(timer);
      status.textContent = 'Saving...';
      return fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      })
        .then(function (response) {
          if (!response.ok) throw new Error();
          status.textContent = 'Saved';
        })
        .catch(function () {
          status.textContent = 'Could not save. Please try again.';
        });
    }

    note.addEventListener('input', function () {
      window.clearTimeout(timer);
      status.textContent = 'Saving...';
      timer = window.setTimeout(saveNote, 450);
    });
    note.addEventListener('change', saveNote);
  }

  function announceCartUpdate(cart) {
    var detail = { cart: cart, source: 'cart-page' };
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cartUpdate', { detail: detail }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
  }

  async function updateLine(context, quantity, previousValue) {
    if (!Number.isInteger(context.line) || context.line < 1) {
      showError(context.row, 'Cart item could not be identified. Please try again.');
      return;
    }

    var key = String(context.line);
    if (pendingLines.has(key)) return;
    pendingLines.add(key);
    setBusy(context.row, true);
    clearError(context.row);

    try {
      var details = sectionDetails();
      var payload = { line: context.line, quantity: quantity };
      if (details.ids.length) {
        payload.sections = details.ids;
        payload.sections_url = window.location.pathname + window.location.search;
      }

      var response = await fetch(changeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      var cart = await response.json().catch(function () { return {}; });
      if (!response.ok || cart.status) {
        throw new Error(cart.description || cart.message || 'There was an error while updating your cart. Please try again.');
      }

      var sections = cart.sections || null;
      if (!sections && details.ids.length) sections = await fetchRenderedSections(details);
      if (sections) renderCartSections(sections, cart, details);

      updateCartCount(cart);
      installCartNote(cart);
      await hydrateComparePrices(cart);
      announceCartUpdate(cart);
    } catch (error) {
      if (context.input && context.input.isConnected && previousValue != null) context.input.value = String(previousValue);
      setBusy(context.row, false);
      showError(context.row, error && error.message);
    } finally {
      pendingLines.delete(key);
    }
  }

  document.addEventListener('click', function (event) {
    var target = eventElement(event.target);
    if (!target || !target.closest) return;

    var button = target.closest('cart-items quantity-input button');
    if (button) {
      var action = buttonAction(button);
      if (!action) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var context = lineContext(button);
      if (!context.input || context.input.disabled) return;

      var current = numberValue(context.input.value, 1);
      var min = numberValue(context.input.min || context.input.dataset.min, 1);
      var max = context.input.max ? numberValue(context.input.max, Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY;
      var step = Math.max(numberValue(context.input.step, 1), 1);
      var next = action === 'plus' ? current + step : current - step;
      next = Math.max(min, Math.min(max, next));
      if (next === current) return;

      context.input.value = String(next);
      updateLine(context, next, current);
      return;
    }

    var removeControl = target.closest('cart-items cart-remove-button, cart-items cart-remove-button a, cart-items cart-remove-button button');
    if (removeControl) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var removeContext = lineContext(removeControl);
      updateLine(removeContext, 0, removeContext.input ? numberValue(removeContext.input.value, 1) : null);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var target = eventElement(event.target);
    if (!target || !target.matches || !target.matches('cart-items input.quantity__input, cart-items input[name="updates[]"]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var context = lineContext(target);
    var previous = numberValue(target.defaultValue, 1);
    var min = numberValue(target.min || target.dataset.min, 1);
    var max = target.max ? numberValue(target.max, Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY;
    var quantity = Math.max(min, Math.min(max, numberValue(target.value, previous)));
    target.value = String(quantity);
    updateLine(context, quantity, previous);
  }, true);

  function initialize() {
    addStyles();
    fetch(cartJsonUrl, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        installCartNote(cart);
        hydrateComparePrices(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
